// @ts-nocheck
import styled from 'styled-components';

export const ReportingAdvancedFilterModalStyled = styled.div`
  .advancedFilterModal {
    &__modal {
      .modalUI__container {
        margin: 24px;
      }
    }

    &__button {
      width: 230px;
    }
  }
`;
